import React from "react"

import classNames from "src/classNames"

export type UnreadBadgeProps = {
  count: number
  blue?: boolean
}

const UnreadBadge: React.FC<UnreadBadgeProps> = ({ count, blue = false }) => {
  return count ? (
    <span
      className={classNames(
        "ml-1 rounded-full px-2 py-1 text-xs font-bold text-white",
        blue ? "bg-blue-500" : "bg-red-500"
      )}
    >
      {count < 100 ? count : "99+"}
    </span>
  ) : null
}

export default UnreadBadge
